import { useState, ReactNode } from 'react';
import { Button, Col, Collapse } from 'react-bootstrap';

type CollapseFieldProps = {
    title: string;
    hintText?: string;
    buttonStyle?: string;
    hintTextColor?: string;
    children?: ReactNode;
};

export default function CollapseField({
    title,
    hintText,
    buttonStyle = '',
    hintTextColor = '#939598',
    children,
}: CollapseFieldProps) {
    const [open, setOpen] = useState(false);

    return (
        <div>
            <div className="d-grid gap-2">
                <Button className={buttonStyle} onClick={() => setOpen(!open)} variant="primary">
                    <Col style={{ display: 'flex', justifyContent: 'left' }}>
                        <b>{open ? '▾ ' : '▸ '}{title}</b>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <div style={{ color: hintTextColor }}>
                            <i>{hintText}</i>
                        </div>
                    </Col>
                </Button>
            </div>
            <Collapse in={open}>
                <div>{children}</div>
            </Collapse>
        </div>
    );
}